import React, { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Right-side slide-in drawer used for ticket/PO/inventory detail views.
 * Lightweight — no Radix/Sheet dependency to keep bundle small.
 */
export const DrawerDetail = ({ open, onClose, title, subtitle, children, footer, width = 480, testid = 'drawer-detail' }) => {
  useEffect(() => {
    const onEsc = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    if (open) document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        className={`fixed inset-0 bg-black/30 z-40 transition-opacity duration-200 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      />
      {/* Panel */}
      <aside
        style={{ width }}
        className={`fixed right-0 top-0 h-screen bg-white shadow-[-4px_0_24px_rgba(0,0,0,0.06)] z-50 flex flex-col transform transition-transform duration-300 ease-out ${open ? 'translate-x-0' : 'translate-x-full'} max-w-[100vw]`}
        data-testid={testid}
      >
        <div className="flex items-start justify-between px-6 py-5 border-b border-gray-100">
          <div className="min-w-0 flex-1">
            <h2 className="text-lg font-semibold tracking-tight text-gray-900 truncate">{title}</h2>
            {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="ml-3 h-8 w-8 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 flex items-center justify-center"
            data-testid="drawer-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto vp-scroll px-6 py-5">{children}</div>
        {footer && (
          <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex items-center justify-end gap-2">
            {footer}
          </div>
        )}
      </aside>
    </>
  );
};

export default DrawerDetail;
